import { defineAsyncComponent } from 'vue'
export default {
  layout: defineAsyncComponent(() => import("/src/MotoritOnline.Web/app/layouts/Layout.vue").then(m => m.default || m)),
  "poc-lexus": defineAsyncComponent(() => import("/src/MotoritOnline.Web/app/layouts/pocLexus.vue").then(m => m.default || m))
}